import React from 'react';

import {ModalBuildDeal} from '../modal-build-deal-interstitial/ModalBuildDeal';
import {ModalDisplayMode} from '../../typing/modal-display';
import {useTranslations} from '../../hooks/use-translations';
import ModalRedirectWithLayer from '../modal-redirect-with-layer';
import {ModalDisplayContainer} from './styles';

interface ModalDisplayFactoryProps {
  mode?: ModalDisplayMode;
  modalProps: any;
}
const ModalDisplayFactory: React.FC<ModalDisplayFactoryProps> = ({
  mode,
  modalProps,
}) => {
  const translations = useTranslations().modals;
  switch (mode) {
    case ModalDisplayMode.REDIRECT_CARFAX_SITE:
      return (
        <ModalRedirectWithLayer
          {...modalProps}
          translations={translations.modalCarFaxRedirect}
        />
      );
    case ModalDisplayMode.DEALER_SITE_HANDOFF:
      return (
        <ModalRedirectWithLayer
          {...modalProps}
          translations={translations.modalDealerRedirect}
        />
      );
    case ModalDisplayMode.HANDOFF_BUYING:
      return (
        <ModalDisplayContainer>
          <ModalBuildDeal {...modalProps} handOffContent="onlineBuying" />
        </ModalDisplayContainer>
      );
    default:
      throw new Error(`UNKNOWN MODAL MODE: ${mode}`);
  }
};

export default ModalDisplayFactory;
